import type { FC, ReactNode } from 'react';
import { CurrentUserProvider } from './current-user/current-user';
import { AnalyticsProvider } from './analytics/analytics';
import { CurrentUser } from '../types/CurrentUser';

export const UtilitiesProvider: FC<{
  analytics?: SegmentAnalytics.AnalyticsJS;
  user: CurrentUser;
  children?: ReactNode;
}> = ({ analytics, user, children }) => (
  <CurrentUserProvider user={user}>
    <AnalyticsProvider analytics={analytics}>{children}</AnalyticsProvider>
  </CurrentUserProvider>
);

export * from './analytics/analytics';
